import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
import { ReportService } from '_apis_/reports';
import { ReportInterface } from '../../@types/reports';

// ----------------------------------------------------------------------

type SessionState = {
  isLoading: boolean;
  error: boolean;
  columns: string[];
  rows: string[];
};

const initialState: SessionState = {
  isLoading: false,
  error: false,
  columns: [],
  rows: []
};

const reportService = new ReportService();

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET BOOST SUCCESS
    getSessionListSuccess(state, action) {
      const { columns, rows } = action.payload;
      state.isLoading = false;
      state.rows = rows;
      state.columns = columns;
    }
  }
});

// ----------------------------------------------------------------------

export function getSessionList(report: ReportInterface, showRevenue: boolean) {
  return async () => {
    dispatch(sessionSlice.actions.startLoading());
    try {
      const response = await reportService.getSplunkReport(report);
      if (response.data) {
        const fields: any[] = response.data.fields;
        let columns: any[] = [];
        if (fields && fields.length > 0) {
          fields.forEach((field: any) => {
            if (
              showRevenue ||
              !(field.name === 'Session_Cost' || field.name === 'Total_Session_Cost')
            ) {
              let label = '';
              switch (field.name) {
                case 'Boost_SerialNumber':
                  label = 'Boost Serial Number';
                  break;
                case 'Boost_Group':
                  label = 'Boost Group/ Subgroup/ Site';
                  break;
                case 'Session_Initiated':
                  label = 'Session Initiated (PST)';
                  break;
                case 'Session_Ended':
                  label = 'Session Ended (PST)';
                  break;
                case 'Charging_Duration':
                case 'Total_Charging_Duration':
                  label = 'Total Charging Duration (Min)';
                  break;
                case 'Energy_Dispensed':
                case 'Total_Energy_Dispensed':
                  label = 'Total Energy Dispensed (kWh)';
                  break;
                case 'Peak_Power_Delivered':
                  label = 'Peak Power Delivered (kW)';
                  break;
                case 'Average_Energy':
                  label = 'Average Energy (kWh)';
                  break;
                case 'Peak_Power':
                  label = 'Peak Power (kW)';
                  break;
                case 'VSOC_end':
                  label = 'Vehicle Ending SOC (%)';
                  break;
                case 'VSOC_start':
                  label = 'Vehicle Starting SOC (%)';
                  break;
                case 'BSOC_start':
                  label = 'Boost Starting SOC (%)';
                  break;
                case 'BSOC_end':
                  label = 'Boost Ending SOC (%)';
                  break;
                case 'Port':
                  label = 'Port';
                  break;
                case 'VIN':
                  label = 'VIN';
                  break;
                case 'Session_Cost':
                  label = 'Session Revenue ($)';
                  break;
                case 'Total_Session_Cost':
                  label = 'Total Revenue ($)';
                  break;
                default:
                  label = field.name.replace(/_/g, ' ');
              }

              columns = [
                ...columns,
                {
                  id: field.name,
                  label,
                  alignRight: false
                }
              ];
            }
          }, {});
        }
        const rows = response.data.results.map((row: any) => {
          const record: any = {};
          fields.forEach((field: any) => {
            let value = row[field.name];
            if (
              value &&
              (field.name === 'VSOC_end' ||
                field.name === 'VSOC_start' ||
                field.name === 'BSOC_start' ||
                field.name === 'BSOC_end')
            ) {
              // percentages should follow a zero to 100 scale for this cases
              value = (Number(value) * 100).toFixed(1);
            }
            record[field.name] = value;
          });
          return record;
        });
        dispatch(sessionSlice.actions.getSessionListSuccess({ columns, rows }));
      }
    } catch (error) {
      dispatch(sessionSlice.actions.hasError(error));
    }
  };
}

// Reducer
export default sessionSlice.reducer;
